<template>
  <div :class="{'smart-input_one-row': oneRow}" class="smart-input smart-input_switch">
    <div v-if="caption" class="smart-input__name">
      {{ caption }}
    </div>
    <label class="smart-input__wrapper">
      <!--
      Срабатывает при переключении ручки.
      @event input
      -->
      <input
        v-model="newValue"
        :disabled="disabled"
        :value="checkboxValue"
        class="smart-input__switch"
        type="checkbox"
        @change="$emit('input', newValue)"
      >
      <span class="smart-input__switch-round" />
    </label>
    <div v-if="error" class="smart-input__error-message">
      {{ error }}
    </div>
  </div>
</template>

<script>
/**
 * Компонент для переключателя.
 */
export default {
  props: {
    /**
     * Значение, которое надо передавать через v-model.
     */
    value: {
      type: [Boolean, Array],
      default: false,
    },
    /**
     * Заголовок поля.
     */
    caption: {
      type: String,
      default: "",
    },
    /**
     * Текст ошибки для поля.
     */
    error: {
      type: String,
      default: "",
    },
    /**
     * Опция для отключения возможности ввода в поле.
     */
    disabled: {
      type: Boolean,
      default: false,
    },
    /**
     * Флаг для размещения подписи и поля ввода на одной строке.
     */
    oneRow: {
      type: Boolean,
      default: true,
    },
    /**
     * Значение для чекбокса, которое будет помещено в переменную в v-model как элемент массива, если v-model типа Array.
     */
    checkboxValue: {
      type: String,
      default: "on",
    },
  },
  data() {
    return {
      newValue: this.value,
    };
  },
  watch: {
    /**
     * Наблюдение за оригинальным значением для его синхронизации со внутренним значением компонента и отправкой события `@change`.
     *
     * @param {String} val
     */
    value(val) {
      if (this.newValue === val) {
        return;
      }
      this.newValue = val;
      /**
       * Срабатывает при изменении значения со стороны родительского компонента.
       * @event change
       */
      this.$emit("change", val);
    },
  },
};
</script>

<style lang="scss">
@use "./scss/style.scss";
</style>
